module.exports = __webpack_public_path__ + "static/media/hoodSliceDiagonal.3f3e4fb9.png";